import consumer from "./consumer";
import CableReady from "cable_ready";

consumer.subscriptions.create(
  { channel: "PaymentsChannel", payer: "stream" },
  {
    received(data) {
      if (!data.operations || data.operations.length === 0) return;

      const operation = data.operations[0];
      const otherData = operation.otherData || {};

      const detail = {
        status: otherData.status || operation.status,
        reference: otherData.reference || operation.reference,
        otherData: otherData,
      };

      document.dispatchEvent(
        new CustomEvent("payment:succeed", { bubbles: true, detail: detail })
      );

      if (data.cableReady) {
        const validOperations = data.operations.filter(function (op) {
          if (!op.selector) return true;
          return document.querySelector(op.selector) !== null;
        });

        if (validOperations.length > 0) {
          CableReady.perform(validOperations);
        }
      }
    },
  }
);
